import React, { useState, useEffect } from 'react';
import { heroContent } from '../data/mock';

const HeroSection = ({ overlayVariant = 'default', textColor = 'white' }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const getOverlay = () => {
    if (overlayVariant === 'copper') {
      return (
        <div className="absolute inset-0 bg-[#e4a483]/[0.55]" />
      );
    }
    if (overlayVariant === 'none') return null;
    
    // Default green gradient
    return (
      <>
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a441f]/70 via-[#1a441f]/50 to-[#1a441f]/90" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1a441f]/30 to-transparent" />
      </>
    );
  };

  const getMainTextColor = () => {
    return textColor === 'green' ? 'text-[#1a441f]' : 'text-[#f8f8f8]';
  };

  const getSubTextColor = () => {
    return textColor === 'green' ? 'text-[#1a441f]' : 'text-[#e4a483]';
  };

  const getDescTextColor = () => {
    return textColor === 'green' ? 'text-[#1a441f]/90' : 'text-[#f8f8f8]/90';
  };

  return (
    <section className="relative h-dvh w-full overflow-hidden" style={{ height: '100dvh' }}>
      {/* Video Background */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <iframe
          className="absolute top-1/2 left-1/2 w-[112vw] h-[63vw] min-h-[112vh] min-w-[199vh] -translate-x-1/2 -translate-y-[53%] pointer-events-none"
          src="https://www.youtube.com/embed/ujaA-Sbdtvo?autoplay=1&mute=1&controls=0&loop=1&playlist=ujaA-Sbdtvo&showinfo=0&rel=0&iv_load_policy=3&disablekb=1&modestbranding=1"
          title="Background Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        {/* Multi-layer Overlay for depth */}
        {getOverlay()}
      </div>

      {/* Content */}
      <div className="relative z-10 h-full w-full">
        {/* Main Headline - Massive Bottom Left Aligned */}
        <div className="absolute bottom-10 left-2 lg:bottom-14 lg:left-8 z-10 w-full pointer-events-none">
          <div
            className={`transition-all duration-1000 ${
              isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h1 className="font-medium text-[#e5e5e5] flex flex-col whitespace-nowrap">
              <span
                className="block text-[clamp(4rem,14vw,18rem)] leading-[0.85] tracking-tight"
                style={{ fontFamily: "'Spirits Soft', 'Figtree', sans-serif" }}
              >
                Generational
              </span>
              <span
                className="block text-[clamp(4rem,14vw,18rem)] leading-[0.85] tracking-tight"
                style={{ fontFamily: "'Spirits Soft', 'Figtree', sans-serif" }}
              >
                Wealth Society
              </span>
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
